import { type MutationError, trpc } from '@/shared/api';

interface UseSetPrintMethodDescriptionOptions {
  readonly onSuccess?: () => void;
}

/** 인쇄 방식 설명 저장 — 고객 상세의 프린트 가이드 본문. 비우면 null 로 저장된다. */
export const useSetPrintMethodDescription = ({
  onSuccess,
}: UseSetPrintMethodDescriptionOptions = {}) => {
  const mutation = trpc.productManagement.printMethods.setDescription.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setDescription: mutation.mutate,
    /** 저장이 진행 중인 인쇄 방식 id — 진행 표시를 해당 행에만 스코프한다. */
    pendingId: mutation.isPending ? (mutation.variables?.id ?? null) : null,
    isPending: mutation.isPending,
    error,
    reset: mutation.reset,
  };
};
